import React from 'react';
import { Timeline, TimelineEvent } from 'react-event-timeline';
import { getComments } from './api';
import { useQuery } from '@apollo/client';
import { Loader } from '../Loader';

interface Props {
  verifyId: number;
  barCode: string;
}

export const CommentsTimeline = (props: Props) => {

  const { loading, error, data } = useQuery(getComments, {
    variables: { verifyId: Number(props.verifyId), barcode: props.barCode },
    fetchPolicy: 'no-cache',
  });

  const sortByCreatedDate = (a: any, b: any) => {
    if (new Date(a.Created_On).getTime() > new Date(b.Created_On).getTime()) {
      return -1;
    } else return 1;
  };

  if (loading) return <Loader />;
  if (error) return <div>error</div>;
  return (
    <Timeline lineColor='white'>
      {[...data.readComments].sort(sortByCreatedDate).map(
        (
          commentObject: any,
          index: number //Want a real type here
        ) => (
          <TimelineEvent
            icon={<span className='fa fa-comment' />}
            bubbleStyle={{ backgroundColor: '#afafaf', borderColor: 'black' }}
            titleStyle={{ fontSize: 15 }}
            subtitleStyle={{ fontSize: 12 }}
            contentStyle={{ fontSize: 16 }}
            title={`Created by : ${commentObject.lastUpdatedBy}`}
            key={index}
            subtitle={commentObject.createdOn}>
            {commentObject.comment}
          </TimelineEvent>
        )
      )}
    </Timeline>
  );
};
